import {createTheme, responsiveFontSizes} from '@material-ui/core/styles'

const IFuturaPTDemi: any = {
    fontFamily: 'FuturaPT',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 300,
    src: `local('FuturaPT'), url('https://dashboard.emailwish.com/assets/fonts/FuturaPT-Demi.ttf') format('truetype')`,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};

const IFuturaPTHeavy: any = {
    fontFamily: 'FuturaPT',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 500,
    src: `local('FuturaPT'), url('https://dashboard.emailwish.com/assets/fonts/FuturaPTHeavy.ttf') format('truetype')`,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
const IFuturaPTBold: any = {
    fontFamily: 'FuturaPT',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 600,
    src: `local('FuturaPT'), url('https://dashboard.emailwish.com/assets/fonts/FuturaPTBold.ttf') format('truetype')`,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};
// const IFuturaPTLight: any = {
//     fontFamily: 'FuturaPT',
//     fontStyle: 'normal',
//     fontDisplay: 'swap',
//     fontWeight: 400,
//     src: `local('FuturaPT'), url(${FuturaPTLight}) format('truetype')`,
//     unicodeRange:
//         'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
// };
const IFuturaPTBook: any = {
    fontFamily: 'FuturaPT',
    fontStyle: 'normal',
    fontDisplay: 'swap',
    fontWeight: 400,
    src: `local('FuturaPT'), url('https://dashboard.emailwish.com/assets/fonts/FuturaPTBook.ttf') format('truetype')`,
    unicodeRange:
        'U+0000-00FF, U+0131, U+0152-0153, U+02BB-02BC, U+02C6, U+02DA, U+02DC, U+2000-206F, U+2074, U+20AC, U+2122, U+2191, U+2193, U+2212, U+2215, U+FEFF',
};


const theme = createTheme({
    typography: {
        fontFamily: 'var(--ew-body-font)',
        subtitle1: {
            color: "black"
        },
        body1: {
            fontSize: "18px",
        },
        button: {
            textTransform: "none",
            fontWeight: 500,
            fontSize: "12px",
        }
    },
    palette: {
        background: {
            default: '#f6f6f7',
        },
        primary: {
            main: '#6500ff',
            dark: '#5200d6',
            contrastText: '#fff',
        },
        secondary: {
            main: '#64748b',
            contrastText: '#fff',
        },

        info: {
            main: '#b35a22',
            contrastText: '#fff',
        },
        warning: {
            main: '#6500ff',
            contrastText: '#fff',
        }
    },
    overrides: {
        MuiCssBaseline: {
            '@global': {
                '@font-face': [IFuturaPTHeavy, IFuturaPTBold, IFuturaPTBook,IFuturaPTDemi],
            },
        },
        MuiButton: {
            /* Match :root --ew-primary-btn-radius / --ew-secondary-btn-radius (999px); avoid square outlines. */
            root: {
                borderRadius: 999,
                textTransform: 'none',
                fontWeight: 500,
                fontSize: '12px',
                letterSpacing: '0.01em',
                padding: '11px 38px',
                border: 'none',
                boxShadow: 'none',
            } as any,
            contained: {
                boxShadow: '0 2px 10px rgba(0, 0, 0, 0.08)',
                border: 'none',
                '&:hover': {
                    boxShadow: '0 4px 16px rgba(0, 0, 0, 0.12)',
                },
            } as any,
            containedPrimary: {
                backgroundColor: '#000000',
                color: '#ffffff',
                border: '1px solid transparent',
                '&:hover': {
                    backgroundColor: '#1a1a1a',
                },
                '&:disabled': {
                    backgroundColor: 'rgba(0, 0, 0, 0.26)',
                    color: 'rgba(255, 255, 255, 0.65)',
                },
            } as any,
            containedSecondary: {
                backgroundColor: '#f3f3f6',
                color: '#0f172a',
                border: '1px solid transparent',
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: '#e8e8ee',
                },
            } as any,
            outlined: {
                borderWidth: '1px',
            } as any,
            outlinedPrimary: {
                borderColor: 'rgba(15, 23, 42, 0.22)',
                color: '#0f172a',
                backgroundColor: 'transparent',
                '&:hover': {
                    borderColor: '#000000',
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
            } as any,
            outlinedSecondary: {
                borderColor: 'rgba(100, 116, 139, 0.45)',
                color: '#475569',
                backgroundColor: 'transparent',
                boxShadow: 'none',
                '&:hover': {
                    borderColor: 'rgba(71, 85, 105, 0.65)',
                    backgroundColor: 'rgba(100, 116, 139, 0.08)',
                },
            } as any,
            textPrimary: {
                color: '#0f172a',
            } as any,
        },
        MuiCheckbox: {
            root: {
                color: 'var(--checkbox-unchecked-icon, rgba(15, 23, 42, 0.45))',
                '&:hover': {
                    backgroundColor: 'rgba(0, 0, 0, 0.04)',
                },
                '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                    color: 'var(--checkbox-checked, #000000)',
                },
                '&.Mui-checked:hover, &.MuiCheckbox-indeterminate:hover': {
                    color: 'var(--checkbox-checked-hover, #1a1a1a)',
                },
                '&.Mui-disabled': {
                    color: 'var(--checkbox-disabled, rgba(0, 0, 0, 0.26))',
                },
            } as any,
            colorPrimary: {
                color: 'var(--checkbox-unchecked-icon, rgba(15, 23, 42, 0.45))',
                '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                    color: 'var(--checkbox-checked, #000000)',
                },
                '&.Mui-checked:hover, &.MuiCheckbox-indeterminate:hover': {
                    color: 'var(--checkbox-checked-hover, #1a1a1a)',
                },
            } as any,
            colorSecondary: {
                color: 'var(--checkbox-unchecked-icon, rgba(15, 23, 42, 0.45))',
                '&.Mui-checked, &.MuiCheckbox-indeterminate': {
                    color: 'var(--checkbox-checked, #000000)',
                },
                '&.Mui-checked:hover, &.MuiCheckbox-indeterminate:hover': {
                    color: 'var(--checkbox-checked-hover, #1a1a1a)',
                },
            } as any,
        },
    },
});
export default responsiveFontSizes(theme)
